<template>
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M36.6665 25.3327C36.6665 24.2281 37.5619 23.3327 38.6665 23.3327H41.3332C42.4377 23.3327 43.3332 24.2281 43.3332 25.3327V27.9994C43.3332 29.1039 42.4377 29.9993 41.3332 29.9993H38.6665C37.5619 29.9993 36.6665 29.1039 36.6665 27.9993V25.3327ZM36.6665 38.666C36.6665 37.5614 37.5619 36.666 38.6665 36.666H41.3332C42.4377 36.666 43.3332 37.5614 43.3332 38.666V54.666C43.3332 55.7706 42.4377 56.666 41.3332 56.666H38.6665C37.5619 56.666 36.6665 55.7706 36.6665 54.666V38.666ZM39.9998 6.66602C21.5998 6.66602 6.6665 21.5993 6.6665 39.9994C6.6665 58.3994 21.5998 73.3327 39.9998 73.3327C58.3998 73.3327 73.3332 58.3994 73.3332 39.9994C73.3332 21.5993 58.3998 6.66602 39.9998 6.66602ZM39.9998 66.666C25.2998 66.666 13.3332 54.6994 13.3332 39.9994C13.3332 25.2994 25.2998 13.3327 39.9998 13.3327C54.6998 13.3327 66.6665 25.2994 66.6665 39.9994C66.6665 54.6994 54.6998 66.666 39.9998 66.666Z"
      fill="#F0811E"
    />
  </svg>
</template>

<script>
export default {
  name: "IconBigWarn",
};
</script>

<style scoped></style>
